<div class="flex flex-col">
    @if (isCurrentDeactivated()) {
        <div class="bg-secondary-orange-light text-secondary-orange-02 rounded px-3 py-2 mb-3 text-sm font-semibold">
            {{ literalService.get('services.routes.deactivatedBanner', true) }}
        </div>
    }
    <!-- Row 1: Pass selector or Name input -->
    <div class="flex flex-col">
        @if (!isCreating) {
            <div class="flex items-center mb-[6px]">
                <label class="font-normal text-base text-primary-purple">{{ literalService.get('services.routes.temporalPass.select', true) }}</label>
            </div>
            <select2
                class="block w-full"
                [placeholder]="literalService.get('services.routes.temporalPass.selectPlaceholder', true)"
                [data]="getPassesForSelect()"
                [value]="editingPass.id"
                [templates]="{option: passOption}"
                (update)="selectPass($event)"
            >
                <ng-template #passOption let-label="label">
                    <app-select2-option [label]="label" />
                </ng-template>
            </select2>
        } @else {
            <div class="flex items-center mb-[6px]">
                <label class="font-normal text-base text-primary-purple">{{ literalService.get('services.routes.temporalPass.name', true) }}</label>
            </div>
            <input
                type="text"
                class="block w-full px-3 py-2 bg-white border rounded font-normal placeholder-slate-400 focus:outline-none"
                [value]="editingPass.name || ''"
                (change)="updateName($event)"
                [placeholder]="literalService.get('services.routes.temporalPass.namePlaceholder', true)"
            />
        }
    </div>

    <!-- Name rename (only in editing mode) -->
    @if (isEditing) {
        <div class="flex flex-col mt-4">
            <label class="font-normal text-base text-primary-purple mb-[6px]">{{ literalService.get('services.routes.temporalPass.name', true) }}</label>
            <input
                type="text"
                class="block w-full px-3 py-2 bg-white border rounded font-normal placeholder-slate-400 focus:outline-none"
                [value]="editingPass.name || ''"
                (change)="updateName($event)"
                [placeholder]="literalService.get('services.routes.temporalPass.namePlaceholder', true)"
            />
        </div>
    }

    <!-- Period type (only when item selected or creating) -->
    @if (editingPass.id || isCreating) {
        <div class="flex flex-col mt-4">
            <label class="font-normal text-base text-primary-purple mb-[6px]">{{ literalService.get('services.routes.temporalPass.type', true) }}</label>
            @if (isCreating || isEditing) {
                <select2
                    class="block w-full"
                    [placeholder]="literalService.get('services.routes.temporalPass.selectTypePlaceholder', true)"
                    [data]="getTemporalTypes()"
                    [value]="editingPass.type"
                    [templates]="{option: typeOption}"
                    (update)="changeType($event)"
                >
                    <ng-template #typeOption let-label="label">
                        <app-select2-option [label]="label" />
                    </ng-template>
                </select2>
            } @else {
                <input
                    type="text"
                    class="block w-full px-3 py-2 bg-white border rounded font-normal placeholder-slate-400 focus:outline-none"
                    [value]="literalService.get('temporalType.' + editingPass.type, true)"
                    disabled
                />
            }
        </div>
    }

    <!-- Price + Usage Limit -->
    @if (editingPass.id || isCreating) {
        <div class="flex gap-4 mt-4">
            <div class="flex flex-col flex-1">
                <label class="font-normal text-base text-primary-purple mb-[6px]">{{ literalService.get('services.routes.temporalPass.price', true) }}</label>
                <input
                    type="number"
                    step="0.01"
                    class="block w-full px-3 py-2 bg-white border rounded font-normal placeholder-slate-400 focus:outline-none"
                    [value]="editingPass.price"
                    [disabled]="!isCreating && !isEditing"
                    (change)="updatePrice($event)"
                    [placeholder]="literalService.get('services.routes.temporalPass.pricePlaceholder', true)"
                />
            </div>
            <div class="flex flex-col flex-1">
                <label class="font-normal text-base text-primary-purple mb-[6px]">{{ literalService.get('services.routes.temporalPass.usageLimit', true) }}</label>
                <input
                    type="number"
                    min="0"
                    class="block w-full px-3 py-2 bg-white border rounded font-normal placeholder-slate-400 focus:outline-none"
                    [value]="editingPass.usageLimit"
                    [disabled]="!isCreating && !isEditing"
                    (change)="updateUsageLimit($event)"
                    [placeholder]="literalService.get('services.routes.temporalPass.usageLimitPlaceholder', true)"
                />
            </div>
        </div>
    }

    <!-- Fares multiselect -->
    @if (editingPass.id || isCreating) {
        <div class="flex flex-col mt-4">
            <label class="font-normal text-base text-primary-purple mb-[6px]">{{ literalService.get('services.routes.temporalPass.fares', true) }}</label>
            @if (isCreating || isEditing) {
                <select2
                    class="block w-full"
                    multiple="true"
                    [placeholder]="literalService.get('services.routes.temporalPass.faresPlaceholder', true)"
                    [data]="getFaresForSelect()"
                    [value]="getSelectedFareIds()"
                    [templates]="{option: fareOption}"
                    (update)="changeFares($event)"
                >
                    <ng-template #fareOption let-label="label">
                        <app-select2-option [label]="label" />
                    </ng-template>
                </select2>
            } @else {
                <input
                    type="text"
                    class="block w-full px-3 py-2 bg-white border rounded font-normal placeholder-slate-400 focus:outline-none"
                    [value]="getSelectedFaresLabel()"
                    disabled
                />
            }
        </div>
    }

    <!-- Round to natural period -->
    @if (editingPass.id || isCreating) {
        <div class="flex items-center mt-4 gap-2">
            <input
                type="checkbox"
                class="w-4 h-4"
                [checked]="editingPass.roundToNaturalPeriod"
                [disabled]="!isCreating && !isEditing"
                (change)="toggleRoundToNaturalPeriod($event)"
            />
            <label class="font-normal text-base text-primary-purple">{{ literalService.get('services.routes.temporalPass.roundToNaturalPeriod', true) }}</label>
        </div>
    }

    <!-- Footer Buttons -->
    @if (!hideFooter) {
        <div class="flex items-center mt-8" [ngClass]="{'justify-center': isCreating || isEditing, 'justify-end': !isCreating && !isEditing}">
            @if (isCreating || isEditing) {
                <button type="button" class="secondary mr-5 gap-4 p-2 border-2 font-semibold w-full uppercase cursor-pointer" (click)="cancelEdit()">
                    {{ literalService.get('cancel', true) }}
                </button>
                <button type="button" class="primary gap-4 p-2 border-2 font-semibold w-full uppercase cursor-pointer text-white" [disabled]="!isFormValid()" (click)="onSubmit()">
                    {{ literalService.get('save', true) }}
                </button>
            } @else {
                <button type="button" class="primary gap-4 px-6 py-2 border-2 font-semibold uppercase cursor-pointer text-white" (click)="startCreating()">
                    {{ literalService.get('services.routes.temporalPass.new', true) }}
                </button>
            }
        </div>
    }
</div>
